export default __webpack_public_path__ + "static/media/img_step_index01.4d1464dd.png";